const aws_region = "us-west-2";

const config = {
  appName: "Trust UI - Non Prod",
  region: aws_region,
  cognito: {
    userPoolId: `${aws_region}_BcAzDUCiy`,
    domain: `ispp-trust-co-token-nonprd.auth.${aws_region}.amazoncognito.com`,
    tokenUrl: `https://ispp-trust-co-token-nonprd.auth.${aws_region}.amazoncognito.com/oauth2/authorize`,
    providerId: "ispp-trust-co-identity-provider",
    redirectUrl: "https://citplanmanager.am.staging.principal.com",
    clientId: "618q78lp24i8sjqb5ru7avcnr3",
    scope: "ispp-trust-co-resource-server/read-write",
    readOnlyGroup: "trust-co-read-only-client",
    updateGroup: "ispp-trust-co-read-write-client",
  },
  api: {
    baseUrl: `https://lkamejhhue.execute-api.${aws_region}.amazonaws.com/prod/api`,
  },
};

export default config;
